import React from 'react'


// Hook Imports
import { useSettings } from '../../../hooks/useSetting'
import { useNavigate } from 'react-router-dom'

// Component Imports
import ModeDropDown from '../../../component/shared/mode_drop_down/ModeDropDown'
import UserDropdown from './user_dropdown/UserDropdown'

// Third party Imports
import { Icon } from '@iconify/react/dist/iconify.js'

function Navbar() {
    // Hooks
    const { updateSettings } = useSettings()

    const handleOpenDrawer = () => {
        updateSettings({ isDrawerOpen: true })
    }

    return (
        <div className="sticky top-5 z-50 shrink-0">
            <div className="bg-backgroundPaper py-3 px-4 md:px-6 rounded-sm shadow-lg">
                <div className="flex justify-between items-center">
                    <div className="flex items-center gap-3">
                        <Icon
                            icon="tabler-menu-2"
                            className="cursor-pointer flex lg:hidden"
                            fontSize={24}
                            onClick={handleOpenDrawer}
                        />
                    </div>
                    <div className="flex items-center">
                        <ModeDropDown />
                        <UserDropdown />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Navbar
